import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import { admission, mua, site } from "../../config/api";

import MetaTags from "react-meta-tags";
import Swal from "sweetalert2";

export default class Formregister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      level: "",
      plan: "",
      vga: "",
      typestd: "",
      typestd2: "",
      typestd3: "",
      faculty: "",
      faculty2: "",
      faculty3: "",
      majorid: "",
      majorid2: "",
      majorid3: "",

      checkfaculty: false,
      checkfaculty2: false,

      array_Typestd: [],
      array_faculty: [],
      array_faculty2: [],
      array_faculty3: [],
      array_major: [],
      array_major2: [],
      array_major3: [],
    };
    this.handleTypestdChange = this.handleTypestdChange.bind(this);
    this.handleTypestd2Change = this.handleTypestd2Change.bind(this);
    this.handleTypestd3Change = this.handleTypestd3Change.bind(this);
    this.handleFacultyChange = this.handleFacultyChange.bind(this);
    // this.handleFaculty2Change = this.handleFaculty2Change.bind(this);
    // this.handleFaculty3Change = this.handleFaculty3Change.bind(this);
    this.handleMajorChange = this.handleMajorChange.bind(this);
    this.handleMajor2Change = this.handleMajor2Change.bind(this);
    this.handleMajor3Change = this.handleMajor3Change.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(event) {
    if (localStorage.getItem("typestudent") === "3") {
      window.location.href = site + '/admission/Formregister-master'
      this.setState({ typestd: "4" });
      this.setState({
        array_faculty: [
          { value: "2", label: "คณะครุศาสตร์" },
          { value: "3", label: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
          { value: "4", label: "คณะวิทยาการจัดการ" },
        ],
      });
      // this.setState({ array_major: [{ value: "8101", label: "การบริหารการศึกษา" }, { value: "8102", label: "ยุทธศาสตร์การบริหารและการพัฒนา" }] });
      this.setState({
        array_major: [{ value: "8103", label: "การจัดการสมัยใหม่" }],
      });
      this.setState({ faculty: "2" });
      this.setState({ majorid: "8102" });
    } else if (localStorage.getItem("typestudent") === "4") {
      window.location.href = site + '/admission/Formregister-master'
      this.setState({ typestd: "7" });
      this.setState({
        array_faculty: [
          { value: "2", label: "คณะครุศาสตร์" },
          // { value: "3", label: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
          // { value: "4", label: "คณะวิทยาการจัดการ" },
        ],
      });
      // this.setState({
      //   array_major: [{ value: "8201", label: "การบริหารการศึกษา" }],
      // });
      // this.setState({ faculty: "2" });
      // this.setState({ majorid: "8202" });
    }else if(localStorage.getItem("typestudent") === "4"){
      window.location.href = site + '/admission/Formregisters'
    }
    this.setState({ level: localStorage.getItem("level") });
    this.setState({ plan: localStorage.getItem("plan") });
    this.setState({ vga: localStorage.getItem("vga") });
    var type = localStorage.getItem("typestudent");
    axios
      .get(
        mua + "/admissionnew2022/showtype/" +
          type
      )
      .then((typestd) => {
        // กรณีปิดประเภทนักศึกษารอบครุศาสตร์
        if (localStorage.getItem("robId") === "121") {
          typestd.data.data.data = typestd.data.data.data.filter(
            ({ type_std_id }) => type_std_id === "1"
          );
        }
        // else if(localStorage.getItem("robId") === "126"){
        //   typestd.data.data.data = typestd.data.data.data.filter(
        //     ({ type_std_id }) => type_std_id === "0"
        //   );
        // }
        ///////////////////////////////

        const options = typestd.data.data.data.map((d) => ({
          value: d.type_std_id,
          label: d.type_std_name,
        }));
        this.setState({ array_Typestd: options });
      });
  }

  handleTypestdChange(event) {
    this.setState({ typestd2: "" });
    this.setState({ typestd3: "" });
    this.setState({ faculty: "" });
    this.setState({ faculty2: "" });
    this.setState({ faculty3: "" });
    this.setState({ majorid: "" });
    this.setState({ majorid2: "" });
    this.setState({ majorid3: "" });
    this.setState({ checkfaculty: false });
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${localStorage.getItem("token")}`,
    });
    var lvl_saka = "1";
    if (event.target.value === "0") {
      lvl_saka = "1";
    }
    let typestudent = "";
    let bee = localStorage.getItem("typestudent");
    if (bee === "0") {
      typestudent = "0";
    } else {
      typestudent = localStorage.getItem("typestudent");
    }
    let typestds;
    // Swal.fire({
    //   text:event.target.value
    // })
    if (event.target.value === "0") {
      typestds = "6";
      // typestds = "0";
    } else {
      typestds = event.target.value;
    }
    //     Swal.fire({
    //   text:typestds
    // })
    let bodydata = {
      typestudent: typestudent,
      level: this.state.level,
      plan: this.state.plan,
      vga: this.state.vga,
      typestd: typestds,
      level_saka: lvl_saka,
      faculty: "",
      faculty2: "",
      faculty3: "",
      courseyear:"1"
    };
    axios
      .post(
        mua + "/admissionnew2022/showfaculty",
        bodydata,
        { headers: headers }
      )
      .then((faculty) => {
      
        // กรณีปิดสาขารอบครุศาสตร์ /////////////
        // if (localStorage.getItem("robId") === "120") {
        //   faculty.data.data.data = faculty.data.data.data.filter(
        //     ({ id_fac }) => !(id_fac === "2")
        //   );
        // } else if (localStorage.getItem("robId") === "121") {
        //   faculty.data.data.data = faculty.data.data.data.filter(
        //     ({ id_fac }) => id_fac === "2"
        //   );
        // }
        ////////////////////////////////////

        const options = faculty.data.data.data.map((d) => ({
          value: d.id_fac,
          label: d.faculty_name,
        }));
        this.setState({ array_faculty: options });
        console.log(options)
      });
  }

  handleTypestd2Change(event) {
    this.setState({ typestd3: "" });
    this.setState({ faculty2: "" });
    this.setState({ faculty3: "" });
    this.setState({ majorid2: "" });
    this.setState({ majorid3: "" });
    this.setState({ [event.target.name]: event.target.value });

    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${localStorage.getItem("token")}`,
    });
    let bodydata = {
      typestudent: localStorage.getItem("typestudent"),
      level: this.state.level,
      plan: this.state.plan,
      vga: this.state.vga,
      typestd: event.target.value,
      level_saka: "2",
      faculty: this.state.faculty,
      faculty2: "",
      faculty3: "",
      courseyear:"1"
    };
    axios
      .post(
        mua + "/admissionnew2022/showfaculty",
        bodydata,
        { headers: headers }
      )
      .then((faculty2) => {
        const options = faculty2.data.data.data.map((d) => ({
          value: d.id_fac,
          label: d.faculty_name,
        }));
        this.setState({ array_faculty2: options });
      });
  }

  handleTypestd3Change(event) {
    this.setState({ faculty3: "" });
    this.setState({ majorid3: "" });
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${localStorage.getItem("token")}`,
    });
    let bodydata = {
      typestudent: localStorage.getItem("typestudent"),
      level: this.state.level,
      plan: this.state.plan,
      vga: this.state.vga,
      typestd: event.target.value,
      level_saka: "3",
      faculty: this.state.faculty,
      faculty2: this.state.faculty2,
      faculty3: "",
      courseyear:"1"
    };
    axios
      .post(
        mua + "/admissionnew2022/showfaculty",
        bodydata,
        { headers: headers }
      )
      .then((faculty3) => {
        const options = faculty3.data.data.data.map((d) => ({
          value: d.id_fac,
          label: d.faculty_name,
        }));
        this.setState({ array_faculty3: options });
      });
  }

  handleFacultyChange(event) {
    console.log(event.target.value);
    this.setState({ typestd2: "" });
    this.setState({ typestd3: "" });
    this.setState({ faculty2: "" });
    this.setState({ faculty3: "" });
    this.setState({ majorid: "" });
    this.setState({ majorid2: "" });
    this.setState({ majorid3: "" });
    this.setState({ checkfaculty: false });
    this.setState({ checkfaculty2: false });
    this.setState({ [event.target.name]: event.target.value });

    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${localStorage.getItem("token")}`,
    });
    var type = "";
    if (localStorage.getItem("typestudent") === "0") {
      type = "6";
    } else {
      type = localStorage.getItem("typestudent");
    }
    var typstd = "";
    if (this.state.typestd === "0") {
      typstd = "6";
    } else {
      typstd = this.state.typestd;
    }
    let bodydata = {
      typestudent: type,
      level: this.state.level,
      plan: this.state.plan,
      vga: this.state.vga,
      typestd: typstd,
      level_saka: "1",
      faculty: event.target.value,
      faculty2: "",
      faculty3: "",
      saka1: "",
      saka2: "",
      saka3: "",
      courseyear:"1"
    };
    axios
      .post(
        mua + "/admissionnew2022/showsaka",
        bodydata,
        { headers: headers }
      )
      .then((major) => {
        // console.log(major.data);
        if (this.state.typestd === "4" || this.state.typestd === "7") {
          axios
            .post(
              admission + "/faculty/ShowMajorBandit",
              {
                typestd: this.state.typestd,
                facid: event.target.value,
              }
            )
            .then((res) => {
              this.setState({ array_major: res.data });
              console.log(res.data);
            });
        } else if (this.state.typestd === "6") {
          axios
            .post(
              admission + "/faculty/ShowMajorAssist",
              {
                typestd: this.state.typestd,
                facid: event.target.value,
              }
            )
            .then((res) => {
              this.setState({ array_major: res.data });
              console.log(res.data);
            });
        } else {
          if (major.data.data.data.length !== 0) {
            let i = 0;
            while (i < major.data.data.data.length) {
              if (major.data.data.data[i].LEVEL_OPEN_NAME === null) {
                major.data.data.data[i].LEVEL_OPEN_NAME =
                  major.data.data.data[i].LEVEL_NAME;
              }
              i++;
            }
            const options2 = major.data.data.data.map((d) => ({
              value: d.MAJOR_ID + "," + d.LEVEL_NAME + "," + d.MAJOR_NAME,
              label: d.MAJOR_NAME + " (" + d.LEVEL_OPEN_NAME + ")",
            }));
            this.setState({ array_major: options2 });
          }
        }
      });
  }

  // handleFaculty2Change(event) {
  //   this.setState({ majorid2: "" });
  //   this.setState({ typestd3: "" });
  //   this.setState({ faculty3: "" });
  //   this.setState({ majorid3: "" });
  //   this.setState({ checkfaculty2: false });
  //   this.setState({ [event.target.name]: event.target.value });
  //   let headers = new Headers({
  //     "Content-Type": "application/x-www-form-urlencoded",
  //     Authorization: `Basic ${localStorage.getItem("token")}`,
  //   });
  //   let bodydata = {
  //     typestudent: localStorage.getItem("typestudent"),
  //     level: this.state.level,
  //     plan: this.state.plan,
  //     vga: this.state.vga,
  //     typestd: this.state.typestd,
  //     level_saka: "1",
  //     faculty: this.state.faculty,
  //     faculty2: event.target.value,
  //     faculty3: "",
  //     saka1: this.state.majorid,
  //     saka2: "",
  //     saka3: "",
  //   };
  //   axios
  //     .post(
  //       mua + "/admissionnew2022/showsaka",
  //       bodydata,
  //       { headers: headers }
  //     )
  //     .then((major) => {
  //       const options2 = major.data.data.data.map((d) => ({
  //         value: d.MAJOR_ID,
  //         label: d.MAJOR_NAME + " (" + d.LEVEL_OPEN_NAME + ")",
  //       }));
  //       this.setState({ array_major2: options2 });
  //     });
  // }

  // handleFaculty3Change(event) {
  //   this.setState({ faculty3: "" });
  //   this.setState({ majorid3: "" });
  //   this.setState({ [event.target.name]: event.target.value });

  //   let headers = new Headers({
  //     "Content-Type": "application/x-www-form-urlencoded",
  //     Authorization: `Basic ${localStorage.getItem("token")}`,
  //   });
  //   let bodydata = {
  //     typestudent: localStorage.getItem("typestudent"),
  //     level: this.state.level,
  //     plan: this.state.plan,
  //     vga: this.state.vga,
  //     typestd: this.state.typestd,
  //     level_saka: "1",
  //     faculty: this.state.faculty,
  //     faculty2: this.state.faculty2,
  //     faculty3: event.target.value,
  //     saka1: this.state.majorid,
  //     saka2: this.state.majorid2,
  //     saka3: "",
  //   };
  //   axios
  //     .post(
  //       mua + "/admissionnew2022/showsaka",
  //       bodydata,
  //       { headers: headers }
  //     )
  //     .then((major) => {
  //       const options3 = major.data.data.data.map((d) => ({
  //         value: d.MAJOR_ID,
  //         label: d.MAJOR_NAME + " (" + d.LEVEL_OPEN_NAME + ")",
  //       }));
  //       this.setState({ array_major3: options3 });
  //     });
  // }

  handleMajorChange(event) {
    var spiltmajor = event.target.value.split(",");
    this.setState({ typestd2: "" });
    this.setState({ typestd3: "" });
    this.setState({ faculty2: "" });
    this.setState({ faculty3: "" });
    this.setState({ majorid2: "" });
    this.setState({ majorid3: "" });
    this.setState({ [event.target.name]: spiltmajor[0] });
    // if(spiltmajor[1] === "ครุศาสตรบัณฑิต" || spiltmajor[1] === "หลักสูตรควบระดับปริญญาตรี 2 ปริญญา (ครุศาสตรบัณฑิต 4 ปี และวิทยาศาสตรบัณฑิต 4 ปี)" || (spiltmajor[1] === "ศิลปศาสตรบัณฑิต" && spiltmajor[2] === "ภาษาอังกฤษ ")){
    if (
      spiltmajor[0] === "1101" ||
      spiltmajor[0] === "1102" ||
      spiltmajor[0] === "1103" ||
      spiltmajor[0] === "1109" ||
      spiltmajor[0] === "1201" ||
      spiltmajor[0] === "1202" ||
      spiltmajor[0] === "1203" ||
      spiltmajor[0] === "1204" ||
      spiltmajor[0] === "1205" ||
      spiltmajor[0] === "1206" ||
      spiltmajor[0] === "1207" ||
      spiltmajor[0] === "1208" ||
      spiltmajor[0] === "1209" ||
      spiltmajor[0] === "1210" ||
      spiltmajor[0] === "1301" ||
      spiltmajor[0] === "1302" ||
      spiltmajor[0] === "1303" ||
      spiltmajor[0] === "1506"
    ) {
      this.setState({ checkfaculty: true });
    } else {
      this.setState({ checkfaculty: false });
    }
  }

  handleMajor2Change(event) {
    // this.setState({ [event.target.name]: event.target.value });
    this.setState({ typestd3: "" });
    this.setState({ faculty3: "" });
    this.setState({ majorid3: "" });
    var spiltmajor = event.target.value.split(",");
    this.setState({ [event.target.name]: spiltmajor[0] });
    // if(spiltmajor[1] === "ครุศาสตรบัณฑิต" || spiltmajor[1] === "หลักสูตรควบระดับปริญญาตรี 2 ปริญญา (ครุศาสตรบัณฑิต 4 ปี และวิทยาศาสตรบัณฑิต 4 ปี)" || (spiltmajor[1] === "ศิลปศาสตรบัณฑิต" && spiltmajor[2] === "ภาษาอังกฤษ ")){
    if (
      spiltmajor[0] === "1101" ||
      spiltmajor[0] === "1102" ||
      spiltmajor[0] === "1103" ||
      spiltmajor[0] === "1109" ||
      spiltmajor[0] === "1201" ||
      spiltmajor[0] === "1202" ||
      spiltmajor[0] === "1203" ||
      spiltmajor[0] === "1204" ||
      spiltmajor[0] === "1205" ||
      spiltmajor[0] === "1206" ||
      spiltmajor[0] === "1207" ||
      spiltmajor[0] === "1208" ||
      spiltmajor[0] === "1209" ||
      spiltmajor[0] === "12301" ||
      spiltmajor[0] === "110" ||
      spiltmajor[0] === "1302" ||
      spiltmajor[0] === "1303" ||
      spiltmajor[0] === "1305" ||
      spiltmajor[0] === "1506"
    ) {
      this.setState({ checkfaculty2: true });
    } else {
      this.setState({ checkfaculty2: false });
    }
  }

  handleMajor3Change(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    localStorage.setItem("typestd", this.state.typestd);
    localStorage.setItem("typestd2", this.state.typestd2);
    localStorage.setItem("typestd3", this.state.typestd3);
    localStorage.setItem("faculty", this.state.faculty);
    localStorage.setItem("faculty2", this.state.faculty2);
    localStorage.setItem("faculty3", this.state.faculty3);
    localStorage.setItem("majorid", this.state.majorid);
    localStorage.setItem("majorid2", this.state.majorid2);
    localStorage.setItem("majorid3", this.state.majorid3);
    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formprofile`;
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลสาขาที่สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลสาขาที่สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ข้อมูลสาขาที่สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          {localStorage.getItem("typestudent") === "1" ? (
            <>
              <h4>
                สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์)
                มหาวิทยาลัยราชภัฏกำแพงเพชร
              </h4>
            </>
          ) : (
            <>
              {localStorage.getItem("typestudent") === "2" ? (
                <>
                  <h4>
                    สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์)
                    มหาวิทยาลัยราชภัฏกำแพงเพชร
                  </h4>
                </>
              ) : (
                <>
                  {localStorage.getItem("typestudent") === "3" ? (
                    <>
                      <h4>สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                    </>
                  ) : (
                    <>
                      {localStorage.getItem("typestudent") === "4" ? (
                        <>
                          <h4>
                            สมัครเรียนปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร
                          </h4>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("typestudent") === "5" ? (
                            <>
                              <h4>
                                สมัครเรียนประกาศนียบัตรบัณฑิต
                                สาขาวิชา/วิชาเอกชีพครู
                                มหาวิทยาลัยราชภัฏกำแพงเพชร
                              </h4>
                            </>
                          ) : (
                            <>
                              {localStorage.getItem("typestudent") === "6" ? (
                                <>
                                  <h4>
                                    สมัครเรียนประกาศนียบัตรผู้ช่วยพยาบาล
                                    มหาวิทยาลัยราชภัฏกำแพงเพชร
                                  </h4>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
          <form onSubmit={this.handleSubmit}>
            <MDBRow>
              <MDBCol lg="1" md="1" sm="1"></MDBCol>
              <MDBCol lg="10" md="10" sm="10">
                <MDBCard >
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBCardTitle>
                        สาขาวิชา/วิชาเอก/วิชาเอกที่ต้องการสมัครเรียน
                      </MDBCardTitle>
                      <MDBCardText>
                        <div className="form-outline">
                          <label className="form-label" for="typestd">
                            ประเภทนักศึกษา
                          </label>
                          <select
                            className="form-control"
                            id="typestd"
                            name="typestd"
                            onChange={this.handleTypestdChange}
                            required
                          >
                            <option value="" hidden>
                              ---ระบุประเภทนักศึกษา---
                            </option>
                            {this.state.array_Typestd.map((data) => {
                              return data.value === this.state.typestd ? (
                                <>
                                  <option value={data.value} selected>
                                    {data.label}
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                </>
                              );
                            })}
                          </select>
                        </div>
                        <div className="form-outline">
                          <label className="form-label" for="faculty">
                            คณะ
                          </label>
                          <select
                            className="form-control"
                            id="faculty"
                            name="faculty"
                            onChange={this.handleFacultyChange}
                            required
                          >
                            <option value="" hidden>
                              ---ระบุคณะ---
                            </option>
                            {this.state.array_faculty.map((data) => {
                              return data.value === this.state.faculty ? (
                                <>
                                  <option value={data.value} selected>
                                    {data.label}
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                </>
                              );
                            })}
                          </select>
                        </div>

                        <div className="form-outline">
                          <label className="form-label" for="majorid">
                            สาขาวิชา/วิชาเอก
                          </label>
                          <select
                            className="form-control"
                            id="majorid"
                            name="majorid"
                            onChange={this.handleMajorChange}
                            required
                          >
                            <option value="" hidden>
                              ---ระบุสาขาวิชา/วิชาเอก---
                            </option>
                            {this.state.array_major.map((data) => {
                              return data.value === this.state.majorid ? (
                                <>
                                  <option value={data.value} selected>
                                    {data.label}
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                </>
                              );
                            })}
                          </select>
                        </div>
                        <hr/>
                        <div>
                          <br></br>
                          {/* <h6>สาขาวิชา/วิชาเอกลำดับที่ 2</h6> */}

                          {/* <div className="form-outline">
                            <label className="form-label" for="typestd2">
                              ประเภทนักศึกษา
                            </label>
                            <select
                              className="form-control"
                              id="typestd2"
                              name="typestd2"
                              onChange={this.handleTypestd2Change}
                            >
                              <option value="" hidden>
                                ---ระบุประเภทนักศึกษา---
                              </option>
                              {this.state.array_Typestd.map((data) => {
                                return (
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div> */}

                          {/* <div className="form-outline">
                            <label className="form-label" for="faculty2">
                              คณะ
                            </label>
                            <select
                              className="form-control"
                              id="faculty2"
                              name="faculty2"
                              onChange={this.handleFaculty2Change}
                              required={
                                this.state.typestd2 === "" ? false : true
                              }
                            >
                              <option value="" hidden>
                                ---ระบุคณะ---
                              </option>
                              {this.state.array_faculty2.map((data) => {
                                return (
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div> */}
                          {/* <div className="form-outline">
                            <label className="form-label" for="majorid2">
                              สาขาวิชา/วิชาเอก
                            </label>
                            <select
                              className="form-control"
                              id="majorid2"
                              name="majorid2"
                              onChange={this.handleMajor2Change}
                              required={
                                this.state.typestd2 === "" ? false : true
                              }
                            >
                              <option value="" hidden>
                                ---ระบุสาขาวิชา/วิชาเอก---
                              </option>
                              {this.state.array_major2.map((data) => {
                                return (
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div> */}
                        </div>
                        {this.state.faculty === "" ||
                        this.state.majorid === "" ? (
                          <>
                            <button
                              type="submit"
                              className="btn btn-info btn-rounded"
                              disabled
                            >
                              บันทึก
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              type="submit"
                              className="btn btn-info btn-rounded"
                            >
                              บันทึก
                            </button>
                          </>
                        )}

                        {/*=============กรณีครุศาสตร์เลือกได้หลายเอก=============*/}

                        {/* <div className="form-outline">
                                                <label className="form-label" for="typestd">ประเภทนักศึกษา</label>
                                                <select className="form-control" id="typestd" name="typestd" onChange={this.handleTypestdChange} required>
                                                    <option value="" hidden>---ระบุประเภทนักศึกษา---</option>
                                                    {this.state.array_Typestd.map((data) => {
                                                        return <option value={data.value}>{data.label}</option>
                                                    })}
                                                </select>
                                            </div>
                                            {this.state.checkfaculty ? <>
                                                <h6>สาขาวิชา/วิชาเอกลำดับที่ 1</h6>
                                            </> : <></>
                                            }
                                            <div className="form-outline">
                                                <label className="form-label" for="faculty">คณะ</label>
                                                <select className="form-control" id="faculty" name="faculty" onChange={this.handleFacultyChange} required>
                                                    <option value="" hidden>---ระบุคณะ---</option>
                                                    {this.state.array_faculty.map((data) => {
                                                        return <option value={data.value}>{data.label}</option>
                                                    })}
                                                </select>

                                            </div>

                                            <div className="form-outline">
                                                <label className="form-label" for="majorid">สาขาวิชา/วิชาเอก</label>
                                                <select className="form-control" id="majorid" name="majorid" onChange={this.handleMajorChange} required>
                                                    <option value="" hidden>---ระบุสาขาวิชา/วิชาเอก---</option>
                                                    {this.state.array_major.map((data) => {
                                                        return <option value={data.value}>{data.label}</option>
                                                    })}
                                                </select>
                                            </div>
                                                  */}
                        {/* {this.state.checkfaculty ? <> */}
                        {/* <br></br>
                                                <h6>สาขาวิชา/วิชาเอกลำดับที่ 2</h6>

                                                <div className="form-outline">
                                                    <label className="form-label" for="typestd2">ประเภทนักศึกษา</label>
                                                    <select className="form-control" id="typestd2" name="typestd2" onChange={this.handleTypestd2Change}>
                                                        <option value="" hidden>---ระบุประเภทนักศึกษา---</option>
                                                        {this.state.array_Typestd.map((data) => {
                                                            return <option value={data.value}>{data.label}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="form-outline">
                                                    <label className="form-label" for="faculty2">คณะ</label>
                                                    <select className="form-control" id="faculty2" name="faculty2" onChange={this.handleFaculty2Change} required={this.state.typestd2 === "" ? false : true}>
                                                        <option value="" hidden>---ระบุคณะ---</option>
                                                        {this.state.array_faculty2.map((data) => {
                                                            return <option value={data.value}>{data.label}</option>
                                                        })}
                                                    </select>

                                                </div>

                                                <div className="form-outline">
                                                    <label className="form-label" for="majorid2">สาขาวิชา/วิชาเอก</label>
                                                    <select className="form-control" id="majorid2" name="majorid2" onChange={this.handleMajor2Change} required={this.state.typestd2 === "" ? false : true}>
                                                        <option value="" hidden>---ระบุสาขาวิชา/วิชาเอก---</option>
                                                        {this.state.array_major2.map((data) => {
                                                            return <option value={data.value}>{data.label}</option>
                                                        })}
                                                    </select>
                                                </div> */}

                        {/*  {this.state.checkfaculty2 ? <>
                                                    <br></br>
                                                    <h6>สาขาวิชา/วิชาเอกลำดับที่ 3</h6>

                                                    <div className="form-outline">
                                                        <label className="form-label" for="typestd3">ประเภทนักศึกษา</label>
                                                        <select className="form-control" id="typestd3" name="typestd3" onChange={this.handleTypestd3Change}>
                                                            <option value="" hidden>---ระบุประเภทนักศึกษา---</option>
                                                            {this.state.array_Typestd.map((data) => {
                                                                return <option value={data.value}>{data.label}</option>
                                                            })}
                                                        </select>
                                                    </div>

                                                    <div className="form-outline">
                                                        <label className="form-label" for="faculty3">คณะ</label>
                                                        <select className="form-control" id="faculty3" name="faculty3" onChange={this.handleFaculty3Change} required={this.state.typestd3 === "" ? false : true}>
                                                            <option value="" hidden>---ระบุคณะ---</option>
                                                            {this.state.array_faculty3.map((data) => {
                                                                return <option value={data.value}>{data.label}</option>
                                                            })}
                                                        </select>
                                                    </div>

                                                    <div className="form-outline">
                                                        <label className="form-label" for="majorid3">สาขาวิชา/วิชาเอก</label>
                                                        <select className="form-control" id="majorid3" name="majorid3" onChange={this.handleMajor3Change} required={this.state.typestd3 === "" ? false : true}>
                                                            <option value="" hidden>---ระบุสาขาวิชา/วิชาเอก---</option>
                                                            {this.state.array_major3.map((data) => {
                                                                return <option value={data.value}>{data.label}</option>
                                                            })}
                                                        </select>
                                                    </div>
                                                    {this.state.typestd3 === "" ? <>
                                                        <button type="submit" className="btn btn-info btn-rounded">บันทึก</button>
                                                    </> : <>
                                                        {this.state.faculty3 === "" || this.state.majorid3 === "" ? <>
                                                            <button type="submit" className="btn btn-info btn-rounded" disabled>บันทึก</button>
                                                        </> : <>
                                                            <button type="submit" className="btn btn-info btn-rounded">บันทึก</button>
                                                        </>}
                                                    </>}
                                                </> : <>
                                                    {this.state.typestd2 === "" ? <>
                                                        <button type="submit" className="btn btn-info btn-rounded">บันทึก</button>
                                                    </> : <>
                                                        {this.state.faculty2 === "" || this.state.majorid2 === "" ? <>
                                                            <button type="submit" className="btn btn-info btn-rounded" disabled>บันทึก</button>
                                                        </> : <>
                                                            <button type="submit" className="btn btn-info btn-rounded">บันทึก</button>
                                                        </>}
                                                    </>}
                                                </>}
                                            </> : <>
                                                {this.state.faculty === "" || this.state.majorid === "" ? <>
                                                    <button type="submit" className="btn btn-info btn-rounded" disabled>บันทึก</button>
                                                </> : <>
                                                    <button type="submit" className="btn btn-info btn-rounded">บันทึก</button>
                                                </>}
                                            </>} */}
                      </MDBCardText>
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="1" sm="1"></MDBCol>
            </MDBRow>
          </form>
        </MDBContainer>
      </>
    );
  }
}


